
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("1yShl"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("1yShl", function(module, exports) {

let $12331207ef372713$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $12331207ef372713$var$load("fSobj"),
    $12331207ef372713$var$load("74u2y"),
    $12331207ef372713$var$load("2YffH"),
    $12331207ef372713$var$load("iDB1L"),
    $12331207ef372713$var$load("eEyVs"),
    $12331207ef372713$var$load("6mHrv"),
    $12331207ef372713$var$load("awWN9"),
    $12331207ef372713$var$load("9CYct"),
    $12331207ef372713$var$load("iIoyG"),
    $12331207ef372713$var$load("2xn4F"),
    $12331207ef372713$var$load("hZtKG"),
    $12331207ef372713$var$load("iNmaF"),
    $12331207ef372713$var$load("lVO3w"),
    $12331207ef372713$var$load("hyzoX"),
    $12331207ef372713$var$load("h9Ed7"),
    $12331207ef372713$var$load("eBRUf"),
    $12331207ef372713$var$load("j8gSv"),
    $12331207ef372713$var$load("8hnOL"),
    $12331207ef372713$var$load("gVbhn"),
    $12331207ef372713$var$load("80E7K"),
    $12331207ef372713$var$load("8A3nE"),
    $12331207ef372713$var$load("8YSo7"),
    $12331207ef372713$var$load("g7ggm"),
    $12331207ef372713$var$load("9S9Mz"),
    $12331207ef372713$var$load("kiGNy"),
    $12331207ef372713$var$load("fuKGN"),
    $12331207ef372713$var$load("4IYLb"),
    $12331207ef372713$var$load("7E8Pd"),
    $12331207ef372713$var$load("g9CVe"),
    $12331207ef372713$var$load("7oiUM"),
    $12331207ef372713$var$load("8t3po"),
    $12331207ef372713$var$load("855o0"),
    $12331207ef372713$var$load("8MfZE"),
    $12331207ef372713$var$load("hv4mn"),
    $12331207ef372713$var$load("dek7I"),
    $12331207ef372713$var$load("3SmkN"),
    $12331207ef372713$var$load("dYtBN"),
    $12331207ef372713$var$load("kNV5Y"),
    $12331207ef372713$var$load("6wr18"),
    $12331207ef372713$var$load("kjZZD"),
    $12331207ef372713$var$load("7nW1A"),
    $12331207ef372713$var$load("cM9rX"),
    $12331207ef372713$var$load("9u7sS"),
    $12331207ef372713$var$load("1fem1"),
    $12331207ef372713$var$load("Wowvf"),
    $12331207ef372713$var$load("ffEVr"),
    $12331207ef372713$var$load("hhss7"),
    $12331207ef372713$var$load("dTsOE"),
    $12331207ef372713$var$load("8hq1F"),
    $12331207ef372713$var$load("7FF6A"),
    $12331207ef372713$var$load("henq4"),
    $12331207ef372713$var$load("k5Ch2"),
    $12331207ef372713$var$load("djob1"),
    $12331207ef372713$var$load("8fMw3"),
    $12331207ef372713$var$load("hogcU"),
    $12331207ef372713$var$load("fjYIR"),
    $12331207ef372713$var$load("h3ABO"),
    $12331207ef372713$var$load("kC80R"),
    $12331207ef372713$var$load("7EorR"),
    $12331207ef372713$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.9c68bcb4.js.map
